/**
 * SeriesGridContainer component
 * @returns <SeriesGridContainer />
 */

import SeriesGridContainerCard from "./SeriesGridContainerCard"

const SeriesGridContainer = ({ items }) => {

    return (
        <section className="corporate_home_bottom">
            <div className="wrapper">

                {items.length > 0 && (
                    items.map((item, i) => {
                        return (
                            <div className="series-grid" key={i}>
                                <p className="series-grid_title">{item.title}</p>
                                <div className="series-grid_container">
                                    {item.boxes.map((box, i) => {
                                        return (
                                            <SeriesGridContainerCard item={box} key={i} />
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </section>
    )
}

export default SeriesGridContainer